import styled from "styled-components";
import theme from "themes/simple-theme";

export interface IProps {
  focused?: boolean;
}

const PinDivider = styled.div`
  /* Base Styling */
  position: absolute;
  width: 0;
  top: 0;
  height: 60px;
  box-sizing: border-box;
  border-right: 1px solid ${theme.color.gray.medium};
  transition: ${theme.global.transition};
  ${({ focused }: IProps) =>
    focused ? `border: 1px solid ${theme.color.primary};` : ``}
`;

export default PinDivider;



// WEBPACK FOOTER //
// ./src/components/common/PinInput/PinDivider.tsx